<div class="main">
    <h1>{{ data.message }}</h1>

    <div class="buttons">
        <button class="button button-orange" (click)="onConfirm()">Okay</button>
    </div>
</div>